<script setup>
import { 
  onMounted, 
  ref,
  defineProps
 } from "vue";

import ProgressSpinner from 'primevue/progressspinner';
import Carousel from 'primevue/carousel';

const props = defineProps({
  full: {
    type: Boolean,
    default: true
  },
  center: {
    type: Boolean,
    default: true
  },
  error: {
    type: String,
  }
});
const list = ref(null);
const books = [
  { name: "Génesis"},
  { name: "Éxodo"},
  { name: "Levítico"},
  { name: "Números"},
  { name: "Deuteronomio"},
  { name: "Josué"},
  { name: "Jueces"},
  { name: "Rut"},
  { name: "1 Samuel"},
  { name: "2 Samuel"},
  { name: "1 Reyes"},
  { name: "2 Reyes"},
  { name: "1 Crónicas"},
  { name: "2 Crónicas"},
  { name: "Esdras"},
  { name: "Nehemías"},
  { name: "Ester"},
  { name: "Job"},
  { name: "Salmos"},
  { name: "Proverbios"},
  { name: "Eclesiastés"},
  { name: "El Cantar de los Cantares"},
  { name: "Isaías"},
  { name: "Jeremías"},
  { name: "Lamentaciones"},
  { name: "Ezequiel"},
  { name: "Daniel"},
  { name: "Oseas"},
  { name: "Joel"},
  { name: "Amós"},
  { name: "Abdías"},
  { name: "Jonás"},
  { name: "Miqueas"},
  { name: "Nahúm"},
  { name: "Habacuc"},
  { name: "Sofonías"},
  { name: "Ageo"},
  { name: "Zacarías"},
  { name: "Malaquías"},
  { name: "Mateo"},
  { name: "Marcos"},
  { name: "Lucas"},
  { name: "Juan"},
  { name: "Hechos"},
  { name: "Romanos"},
  { name: "1 Corintios"},
  { name: "2 Corintios"},
  { name: "Gálatas"},
  { name: "Efesios"},
  { name: "Filipenses"},
  { name: "Colosenses"},
  { name: "1 Tesalonicenses"},
  { name: "2 Tesalonicenses"},
  { name: "1 Timoteo"},
  { name: "2 Timoteo"},
  { name: "Tito"},
  { name: "Filemón"},
  { name: "Hebreos"},
  { name: "Santiago"},
  { name: "1 Pedro"},
  { name: "2 Pedro"},
  { name: "1 Juan"},
  { name: "2 Juan"},
  { name: "3 Juan"},
  { name: "Judas"},
  { name: "Apocalipsis"},
];

onMounted(() => {
  //  obtener un numero entre 0 y el total de libros
  const start = Math.floor(Math.random() * books.length);
  //  obtener 15 libros a partir del numero obtenido
  list.value = [...books, ...books].slice(start, start + 15);

  
});
</script>

<template>
  <div class="page" :class="{
    'full': props.full,
  }">
    <ProgressSpinner v-if="!props.error" />
    <div v-if="props.error" class="text-center border-1 p-2 mb-4 bg-red-500 border-red-300">
      <p class="text-base text-white">{{ props.error }}</p>
    </div>

    <div class="text-xs mt-4" v-if="list">
      Practiquemos de {{ list[0].name }} a {{ list[list.length - 1].name }} mientras esperamos
    </div>
    <!-- {{ list }} -->
    <div class="carousel mt-4">

      <Carousel :value="list" :numVisible="3" :numScroll="3" :showIndicators="false" :showNavigators="false" circular :autoplayInterval="2000" v-if="list">
        <template #item="slotProps">
          <div class="slow-show font-bold text-sm sm:text-base" >
            {{ slotProps.data.name }}
          </div>
        </template>
      </Carousel>

    </div>
  </div>
</template>

<style scoped>

.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
/* .center {
  align-items: center;
  justify-content: center;
} */
.full {
  height: 100vh;
}

.carousel {
  width: 600px;
  max-width: 90%;
  margin: 2rem auto;
}

.slow-show {
  opacity: 0; /* El botón empieza invisible */
  animation: fadeIn .1s forwards; /* Aplica la animación */
  animation-delay: 0s; /* Retrasa el inicio de la animación por 1 segundo */
}

@keyframes fadeIn {
  to {
    opacity: 1; /* El botón se vuelve completamente visible */
  }
}



</style>